function ridToString(value) {
  if (value === null || typeof value === 'undefined') return null;
  if (value && value['@rid']) return ridToString(value['@rid']);

  var rid = String(value).trim();
  if (!rid) return null;
  return rid[0] === '#' ? rid : '#' + rid;
}

function normalizeRidArray(value) {
  if (!Array.isArray(value)) {
    value = value ? [value] : [];
  }

  return value
    .map(ridToString)
    .filter(function (rid, idx, list) {
      return rid && list.indexOf(rid) === idx;
    });
}

function buildGroupRidSet(groups) {
  return new Set(normalizeRidArray((groups || []).map(function (group) {
    return group && (group.value || group['@rid']);
  })));
}

function reconcileCertifiedInstrumentGroups(record, groups) {
  var source = record || {};
  var knownGroupRids = buildGroupRidSet(groups);
  var ownerRids = normalizeRidArray(source.owner);
  var usedByRids = normalizeRidArray(source.usedBy);

  var validOwnerRids = ownerRids.filter(function (rid) {
    return knownGroupRids.has(rid);
  });
  var validUsedByRids = usedByRids.filter(function (rid) {
    return knownGroupRids.has(rid);
  });

  return {
    record: Object.assign({}, source, {
      owner: validOwnerRids,
      usedBy: validUsedByRids
    }),
    missingOwnerRids: ownerRids.filter(function (rid) {
      return !knownGroupRids.has(rid);
    }),
    missingUsedByRids: usedByRids.filter(function (rid) {
      return !knownGroupRids.has(rid);
    })
  };
}

function flagIsEnabled(value) {
  return value === true || value === 1 || value === '1';
}

function userCanEditCertifiedInstrument(record, user, groups) {
  if (!user) return false;
  if (flagIsEnabled(user.isCalibrationSuperuser)) return true;

  var reconciled = reconcileCertifiedInstrumentGroups(record, groups);
  var ownerRids = reconciled.record.owner || [];
  var userGroupRids = new Set(normalizeRidArray((user.groups || []).map(function (group) {
    return group && (group['@rid'] || group.value || group);
  })));

  if (ownerRids.some(function (rid) { return userGroupRids.has(rid); })) {
    return true;
  }

  return ownerRids.length === 0 && flagIsEnabled(user.isSuperuser);
}

module.exports = {
  reconcileCertifiedInstrumentGroups: reconcileCertifiedInstrumentGroups,
  userCanEditCertifiedInstrument: userCanEditCertifiedInstrument,
  __testables: {
    normalizeRidArray: normalizeRidArray,
    ridToString: ridToString
  }
};
